import React from "react";
import { BadgeCheck } from "lucide-react";

const STANDARDS = [
  {
    code: "ASTM B280",
    title: "Seamless Copper Tube for Air Conditioning and Refrigeration Field Service (ACR)",
    detail:
      "Governs the seamless ACR tubing used across our Pancake Coils & Soft Coil ranges. Cleanness limits, dimensions, and chemistry all met.",
  },
  {
    code: "ASTM B743",
    title: "Seamless Copper Tube in Coils",
    detail:
      "Coiled copper tube standard — applied to Economy and Lite Economy Pancake Coil grades, and our Level Wound Coil series.",
  },
  {
    code: "R410A Ready",
    title: "Modern Refrigerant Compatibility",
    detail:
      "All ACR tubes are suitable for Variable Refrigerant Flow (VRF) systems and high-pressure refrigerants including R410A.",
  },
  {
    code: "Tested Mechanicals",
    title: "Field-Verified Performance",
    detail:
      "Annealed for easy field installation. Elongation > 40% · Flaring expansion > 40% OD · Tensile strength > 205 MPa.",
  },
];

export default function Standards() {
  return (
    <section
      id="standards"
      data-testid="standards-section"
      className="bg-[#18181B] text-white py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end mb-16">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-5">
              <span className="section-rule" />
              <span className="text-[#E19672] text-xs tracking-[0.3em] uppercase font-semibold">
                Standards &amp; Compliance
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight leading-[1.05]">
              Produced to the <span className="copper-text">highest standards</span> for outstanding quality &amp; durability.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-[#94A3B8] text-lg leading-relaxed">
              Every coil and length we supply is traceable through incised marking
              and color coding — and conforms to internationally recognized ASTM
              specifications for the HVAC-R industry.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10">
          {STANDARDS.map((s, i) => (
            <div
              key={s.code}
              data-testid={`standard-card-${i}`}
              className="bg-[#18181B] p-8 md:p-10 hover:bg-[#27272A] transition-colors"
            >
              <div className="flex items-center justify-between mb-6">
                <div className="font-mono text-xl text-[#E19672] font-semibold tracking-wider">
                  {s.code}
                </div>
                <BadgeCheck className="text-[#B85C38]" size={22} />
              </div>
              <h3 className="text-2xl font-medium mb-4 leading-tight" style={{ fontFamily: "Outfit, sans-serif" }}>
                {s.title}
              </h3>
              <p className="text-[#94A3B8] text-sm leading-relaxed">{s.detail}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
